import { render } from "./TechnicalWarning.vue?vue&type=template&id=3674900e&scoped=true"
const script = {}

import "./TechnicalWarning.vue?vue&type=style&index=0&id=3674900e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3674900e"]])

export default __exports__